import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { formatCurrency } from "../../lib/constants";

export function RitiroDialog({ open, onClose, stop, form, setForm, onSave, hidePrice = false, showPiva = false }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="ritiro-dialog">
        <DialogHeader>
          <DialogTitle>Registra ritiro</DialogTitle>
          <DialogDescription>Inserisci kg{hidePrice ? "" : ", prezzo"} e note del ritiro</DialogDescription>
        </DialogHeader>
        {stop && (
          <div className="space-y-3">
            <div className="text-sm">
              <div className="font-semibold">{stop.ragioneSociale}</div>
              <div className="text-xs text-slate-500">{stop.indirizzo}</div>
              {showPiva && stop.partitaIva && (
                <div className="text-xs text-slate-500" data-testid="ritiro-dialog-piva">P.IVA {stop.partitaIva}</div>
              )}
            </div>
            <div>
              <Label>Quantità (kg) *</Label>
              <Input type="number" step="0.1" value={form.kg} onChange={(e) => setForm({ ...form, kg: e.target.value })} data-testid="ritiro-kg" autoFocus />
            </div>
            {!hidePrice && (
              <div>
                <Label>Prezzo €/kg</Label>
                <Input type="number" step="0.01" value={form.prezzo} onChange={(e) => setForm({ ...form, prezzo: e.target.value })} data-testid="ritiro-prezzo" />
              </div>
            )}
            <div>
              <Label>Note</Label>
              <Textarea value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} rows={2} data-testid="ritiro-note" />
            </div>
            {!hidePrice && form.kg && form.prezzo && (
              <div className="text-sm text-[#1B5E20] font-semibold">
                Importo: {formatCurrency(Number(form.kg) * Number(form.prezzo))}
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={onSave} className="bg-[#1B5E20] hover:bg-[#144818] text-white" data-testid="ritiro-save-btn">Salva ritiro</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
